import { render, staticRenderFns } from "./LocationsForm.vue?vue&type=template&id=1ef124f3"
import script from "./LocationsForm.vue?vue&type=script&lang=js"
export * from "./LocationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports